import { render, staticRenderFns } from "./CardRegistrationActions.vue?vue&type=template&id=1708743d&scoped=true"
import script from "./CardRegistrationActions.vue?vue&type=script&lang=js"
export * from "./CardRegistrationActions.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrationActions.vue?vue&type=style&index=0&id=1708743d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708743d",
  null
  
)

export default component.exports